// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import {IFetchCourse, IFetchCourses, IFetchMyCourses, IGenerateCourseFile, IGetActivePublicFilters} from 'app_types/campus/academic/courseTypes'
// @end

class CourseService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  fetchCourses = async (params: any) => {
    this.refreshAuthToken()

    let responseData: IFetchCourses

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course/fetch-courses`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchCoursesByCourseSlug = async ({ slug }: { slug: string }) => {
    this.refreshAuthToken()

    let responseData: IFetchCourses

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course/fetch-courses-by-slug`,
      auth_token: this.token,
      params: {
        slug
      },
    }

    responseData = await this.Http.send(queryData)

    return responseData
  }

  getActivePublicFilter = async () => {
    this.refreshAuthToken()

    let responseData: IGetActivePublicFilters

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course/get-active-public-filter`,
      auth_token: this.token,
      params: {
        pageNumber:1,
        nPerPage:1000,
        publish:true,
        startPublicationDate: {
            date:"today",
            direction:"lte"
        },
        endPublicationDate: {
            date:"today",
            direction:"gte"
        }
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchCourse = async (slug: string, params: any) => {
    this.refreshAuthToken()

    let responseData: IFetchCourse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course/fetch-course/${slug}`,
      auth_token: this.token,
      params: {...params},
    }

    responseData = await this.Http.send(queryData)

    return responseData
  }

  generateCourseFile = async (slug: string, params: any = {}) => {
    this.refreshAuthToken()

    let responseData: IGenerateCourseFile

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/course/generate-course-file/${slug}`,
      auth_token: this.token,
      params: {...params},
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchMyCourses = async (params?: any) => {
    this.refreshAuthToken()

    let responseData: IFetchMyCourses

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/enrolledCourse`,
      auth_token: this.token,
      params: params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

}

export default CourseService
